export enum PermissionEnum {
    ViewUsers = 1,

    UpdateUsers = 2,

    DeleteUsers = 3,

    ViewAllQuestions = 4,

    UpdateQuestion = 5,

    AddQuestion = 6,

    DeleteQuestion = 7,    

    ViewOwnSession = 8,

    AddOneSession = 9, //For Free User 

    AddMultipleSessions = 10,//For Premium User

    DeleteSession = 11,

    ArchiveSession = 12,

    RestartSessionAsNew = 13,

    ViewRanking = 14, 

    ViewSimulation = 15,

    AddSimulation = 16,

    DeleteSimulation = 17,

    UpdateSimulation = 18,

    ViewOwnSimulation = 19,

    SaveSimulationResult = 20,

    AddOwnSimulation = 21,

    ViewConfigurations = 22,

    AddConfigurations = 23,

    UpdateConfigurations = 24,

    DeleteConfigurations = 25,

    CalculateSimulationRanks = 26,

    ViewFeedback = 27,

    AddFeedback = 28,

    DeleteFeedback = 29,

    AddAdminFeedBackMessage = 30,

    AddFeedBackMessage = 31,

    ViewAllFeedBack = 32,

    UpdateFeedBack = 33,

    PaymentManagement = 34,

    ResendInvoiceEmail = 35,

    ViewProfile = 36
}